<template>
  <qx-card-form title="登记信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    let that = this;
    return {
      oldInsuranceEndDate: '',
      otherFormData: {
      },
      baseForm: {
        form: [
          {
            label: '保险类型',
            value: 'certificatesInsuranceType',
            type: 'select',
            default: '-1',
            options: [
              { label: '请选择', value: '-1' },
              { value: '0', label: '资产险' },
              { value: '3', label: '交强险' },
              { value: '4', label: '商业险' },
              { value: '6', label: '意外险' },
              { value: '7', label: '超赔险' },
              { value: '5', label: '其他险' },
            ],
          },
          {
            label: '保费（元）',
            value: 'certificatesInsuranceFee',
            type: 'input',
          },
          {
            label: '起保日期',
            value: 'insuranceStartDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '终保日期',
            value: 'insuranceEndDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            onChange: (val) => {
              if (new Date(that.oldInsuranceEndDate) > val && (new Date(that.oldInsuranceEndDate) - new Date()) / (1000 * 60 * 60 * 24 * 30) < 6) {
                this.$message({
                  type: 'info',
                  message: '临近有效日期不能修改为当前有效日期之前的时间！',
                });
                this.$refs.baseForm.setVal('insuranceEndDate', that.oldInsuranceEndDate);
              }
            },
          },
          {
            label: '保单号',
            value: 'insuranceCode',
            type: 'input',
          },
          {
            label: '被保险人',
            value: 'insuranceInsurant',
            type: 'input',
          },
          {
            label: '是否退保',
            value: 'certificatesInsuranceTypelist',
            type: 'select',
            default: '-1',
            options: [
              { label: '请选择', value: '-1' },
              { value: '2', label: '是' },
              { value: '1', label: '否' },
            ],
          },
          {
            label: '退保时间',
            value: 'insuranceTerminationDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '退保费',
            value: 'backInsuranceFee',
            type: 'input',
          },
          {
            label: '保险公司',
            value: 'serviceName',
            type: 'input',
          },
          {
            label: '保单附件',
            // picFileIds
            value: 'picList',
            type: 'file',
            accept: 'pdf,png,jpg',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            tip: '只支持上传图片格式(jpg，png)或pdf格式文件',
          },
        ],
        rules: {
          certificatesInsuranceType: [
            { required: true, message: '请选择保险类型', trigger: 'blur' },
          ],
          certificatesInsuranceFee: [
            { required: true, message: '请输入保费', trigger: 'blur' },
          ],
          insuranceStartDate: [
            { required: true, message: '请选择起保日期', trigger: 'blur' },
          ],
          insuranceEndDate: [
            { required: true, message: '请选择终保日期', trigger: 'blur' },
          ],
          // certificatesInsuranceTypelist: [
          //   { required: true, message: '请选择是否退保', trigger: 'blur' },
          // ],
          // backInsuranceFee: [
          //   { required: true, message: '请输入退保费用', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setVehicleInfo (vehicleInfo) {
      // TODO
    },
    // 从车辆预警列表的处理页面进来
    async jumpFromWarn () {
      const certificatesInsuranceType = this.$route.query.certificatesInsuranceType;
      if (certificatesInsuranceType) {
        this.$refs.baseForm.setVal('certificatesInsuranceType', certificatesInsuranceType);
      }
    },
    initSelect (data, selectFieldName, otherFieldName) {
      if (data[selectFieldName] !== undefined) {
        data[otherFieldName || selectFieldName] = String(data[selectFieldName]) || '-1';
      } else {
        data[otherFieldName || selectFieldName] = '-1';
      }
    },
    // 设置登记日期和注册日期
    setFormVal (plateNumberInfo) {
      this.$refs.baseForm.setVal('registrantionTime', plateNumberInfo.registrantionTime || ' ');
      this.$refs.baseForm.setVal('drivingLicenseDate', plateNumberInfo.drivingLicenseDate || ' ');
    },
    setCertificatesInsuranceType (plateNumberInfo) {
      if (plateNumberInfo.licenceType === 3) {
        this.baseForm.form[0].options = [
          { label: '请选择', value: '-1' },
          { value: '0', label: '资产险' },
          { value: '3', label: '交强险' },
          { value: '4', label: '商业险' },
          { value: '5', label: '其他险' },
        ];
      } else {
        this.baseForm.form[0].options = [
          { label: '请选择', value: '-1' },
          { value: '0', label: '资产险' },
          { value: '3', label: '交强险' },
          { value: '4', label: '商业险' },
          { value: '6', label: '意外险' },
          { value: '7', label: '超赔险' },
          { value: '5', label: '其他险' },
        ];
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.insuranceStartDate = this.formatDate(formData.insuranceStartDate);
        formData.insuranceEndDate = this.formatDate(formData.insuranceEndDate);
        formData.insuranceTerminationDate = this.formatDate(formData.insuranceTerminationDate);
        if (formData.picList && formData.picList.length) {
          for (let item of formData.picList) {
            item.fileId = item.id;
            item.fileUrl = item.url;
          }
        }
        formData.state = formData.certificatesInsuranceTypelist;

      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData.picFileIds = '';
        if (formData.picList && formData.picList.length) {
          let picFileIds = [];
          for (let item of formData.picList) {
            picFileIds.push(item.fileId);
          }
          formData.picFileIds = picFileIds.join();
        }
        delete formData.picList;
      }
      console.log('登记信息提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['certificatesInsuranceType'],
      });

      this.initSelect(data, 'certificatesInsuranceType');
      this.initSelect(data, 'state', 'certificatesInsuranceTypelist');

      let flowIds = [];
      if (data.picList && data.picList.length) {
        const picList = JSON.parse(JSON.stringify(data.picList));
        picList.forEach((item) => {
          flowIds.push(item.fileId);
        });
      }
      if (flowIds.length) {
        const imgs = await getFileUrl({
          flowIds: flowIds.join(),
          _GRID_TYPE: 'jq',
        });
        imgs.rows.forEach((img) => {
          data.picList.forEach((pic) => {
            if (pic.fileId === img.flowId) {
              pic.id = img.flowId;
              pic.url = img.fullPath;
              pic.name = img.fileName;
            }
          });
        });
      }
      this.$refs.baseForm.setVal(data);
      this.oldInsuranceEndDate = data.insuranceEndDate;
      this.jumpFromWarn();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
